import { useParams } from "react-router-dom";
import { useGetPlantGrowthById } from "../../api/scouting";
import { InfoCard } from "../../components/cards/info-card";
import { MetaDataCard } from "../../components/shared/MetaDataCard";

const PlantGrowthDetailPage = () => {
  const { id } = useParams();
  const plantGrowthId = id ? Number(id) : undefined;
  const {
    data: plantGrowth,
    isLoading,
    error,
  } = useGetPlantGrowthById(plantGrowthId as number);

  const plantGrowthDetail = plantGrowth?.data?.data;

  if (isLoading || error) {
    return;
  }

  const growthData = [
    {
      title: "Date",
      value: plantGrowthDetail.date,
    },
    {
      title: "Growth Stage",
      value: plantGrowthDetail.growthStage,
    },
    {
      title: "Irrigation Status",
      value: plantGrowthDetail.irrigationStatus,
    },

    {
      title: "Pest Observation",
      value: plantGrowthDetail.pestObservations,
    },
    {
      title: "Weed Presence",
      value: plantGrowthDetail.weedPresence,
    },
  ];

  return (
    <div className="min-h-screen bg-white py-8 mt-6">
      <div className="p-6 space-y-8">
        <section className="p-6 rounded-2xl border border-[#EBEBEB] gap-[10px]">
          <h2 className="text-base font-semibold text-gray-800 mb-4 pb-2">
            Growth Details
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            {growthData.map((stat, index) => (
              <InfoCard
                title={stat.title}
                value={stat.value as any}
                key={index}
              />
            ))}
          </div>
        </section>

        {/* Recommendations Section */}
        <section className="p-6 rounded-2xl border border-[#EBEBEB] gap-[10px]">
          <div className="text-sm ">
            <p className="text-[#000000]/50">Recommendations</p>
            <p className="text-[#000000]">
              {plantGrowthDetail?.recommendations}
            </p>
          </div>
        </section>

        {/* Metadata Section */}
        <MetaDataCard
          metadata={plantGrowthDetail}
          title="Metadata"
          cardBackgroundColor="white"
        />
      </div>
    </div>
  );
};

export default PlantGrowthDetailPage;
